<!-- 売上日報ダウンロード -->
<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="contents1">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-if="isDataFetched" id="contents1">
    <section class="com_sec1">
      <div class="com_inner1 clearfix">
        <!-- パンくずリスト -->
        <BreadcrumbsComponent :title="''" :categoryId="categoryId" />
        <!-- 文言表示 -->
        <p class="com_fs15">
          売上日報には<span class="com_color1">個人情報</span
          >が含まれます。<br />
          カウネット運用マニュアルに記載されている「顧客情報取扱いの諸注意」に遵守いただきますようお願い申し上げます。
        </p>
        <!-- エラーメッセージの表示エリア -->
        <div
          v-if="errorMessage"
          class="error-message com_mgb10"
          style="white-space: pre-wrap"
        >
          {{ errorMessage }}
        </div>
        <!-- 検索条件 -->
        <div class="com_block1">
          <!-- エージェント一覧 -->
          <div>
            <h2>エージェントコード</h2>
            <p class="com_fs12 com_color1">※必須項目です</p>
          </div>
          <div>
            <table class="com_a_table1">
              <colgroup>
                <col style="width: 5%" />
                <col style="width: 15%" />
                <col style="width: 80%" />
              </colgroup>
              <thead>
                <tr>
                  <th style="width: 5%">
                    <label class="com_checkbox3">
                      <input
                        type="checkbox"
                        :checked="isAllChecked"
                        class="check_all1"
                        @change="toggleAllAgents"
                      />
                    </label>
                  </th>
                  <th>コード</th>
                  <th>エージェント名</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(agent, index) in agList" :key="index">
                  <td>
                    <label class="com_checkbox3">
                      <input
                        type="checkbox"
                        v-model="agent.selection"
                        class="check_all1"
                      />
                    </label>
                  </td>
                  <td>{{ agent.agCode }}</td>
                  <td>{{ agent.agName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p class="com_mgb10">
          ※検索条件のアップロードにはCSVファイルを使用してください。(1行1明細)
        </p>
        <!-- 発行日または売上日 -->
        <div class="com_block1">
          <div>
            <h2>発行日または売上日(選択)</h2>
            <p class="com_fs12 com_color1">※必須項目です</p>
          </div>
          <div>
            <div class="com_b_cnt1">
              <div class="com_f_group1">
                <!-- 日付区分 -->
                <select v-model="inputData.dateKbn" class="com_f_control1">
                  <option value="" disabled></option>
                  <option :value="UriRptDownloadConstants.DATE_KBN_ISSUE">
                    発行日
                  </option>
                  <option :value="UriRptDownloadConstants.DATE_KBN_SALES">
                    売上日
                  </option>
                </select>
                <!-- 開始日 -->
                <input
                  type="date"
                  v-model="inputData.dateFrom"
                  :max="AppConstants.MAX_DATE_VALUE"
                  class="com_f_control1 com_center1"
                  style="width: auto"
                />
                <span class="t1">～</span>
                <!-- 終了日 -->
                <input
                  type="date"
                  v-model="inputData.dateTo"
                  :max="AppConstants.MAX_DATE_VALUE"
                  class="com_f_control1 com_center1"
                  style="width: auto"
                />
                <span class="com_fs14 t2">
                  （年は西暦/最大期間{{
                    getValueById(
                      checkSettings,
                      UriRptDownloadConstants.KEY_CHECK_SETTINGS_DATE_RANGE_DAYS
                    )
                  }}日）
                </span>
              </div>
              <p class="com_fs15 com_lh14 com_mgt10 com_mgb0">
                発行日：売上日報がメールで届いた日付です。&nbsp;&nbsp;&nbsp;売上日：売上日報データの売上日です。<br />
                {{
                  formatMessage(
                    getValueById(
                      displayMessages,
                      UriRptDownloadConstants.KEY_DISPLAY_TEXT_PAST_TARGET_SPAN
                    ),
                    [
                      getValueById(
                        checkSettings,
                        UriRptDownloadConstants.KEY_CHECK_SETTINGS_START_DATE_LOOKBACK_MONTHS
                      ),
                    ]
                  )
                }}
              </p>
            </div>
          </div>
        </div>
        <!-- ボタン部 -->
        <div class="com_u_cnt1">
          <div class="com_inner1 clearfix">
            <div>
              <router-link
                :to="{ name: 'ReportDownload' }"
                class="com_link2 b"
                style="margin-left: 12px"
                >各種ダウンロードへ戻る</router-link
              >
            </div>
            <div>
              <button
                type="button"
                name="btnSerch"
                class="com_search_button1"
                style="width: 180px"
                @click="onSerch"
              >
                売上日報検索
              </button>
              <button
                type="button"
                name="btnClear"
                class="com_clear_button1"
                style="width: 120px; margin-right: 12px"
                @click="onClear"
              >
                クリア
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- 検索結果 -->
      <div
        v-if="outputDataList.length > 0"
        class="com_inner1 clearfix com_mgt15"
      >
        <!-- 上部メッセージ -->
        <div>
          <p class="com_fs15">
            売上日報ファイルを作成しました。ダウンロードリンクをクリックし、ファイルを保存してください。
          </p>
        </div>
        <!-- 操作エリア -->
        <div class="div-kan com_mgb10">
          <div style="display: flex">
            <div>
              <button
                type="button"
                name="btnDownload"
                class="uri_res_button1"
                @click="
                  onDownload(UriRptDownloadConstants.DOWNLOAD_TYPE_TEMPLATE, '')
                "
              >
                Excelひな形ファイル
              </button>
            </div>
            <div>
              <span style="margin-left: 12px; vertical-align: middle">
                {{
                  getValueById(
                    displayMessages,
                    UriRptDownloadConstants.KEY_DISPLAY_TEXT_TEMPLATE_FILE
                  )
                }}
              </span>
            </div>
            <div style="margin-left: 60px">
              <button
                type="button"
                name="btnDownload"
                class="uri_res_button1"
                @click="
                  onDownload(
                    UriRptDownloadConstants.DOWNLOAD_TYPE_ZIP,
                    zipFileName
                  )
                "
              >
                全ファイルダウンロード
              </button>
            </div>
          </div>
        </div>
        <!-- ファイル一覧 -->
        <div style="width: 900px">
          <table class="com_a_table1">
            <thead>
              <tr>
                <th style="width: 20%">エージェントコード</th>
                <th style="width: 35%">エージェント名</th>
                <th style="width: 45%">ダウンロードリンク</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in outputDataList" :key="index">
                <td>{{ data.agCode }}</td>
                <td>{{ data.agName }}</td>
                <td>
                  <a
                    href="#"
                    class="com_link1"
                    @click.prevent="
                      onDownload(
                        UriRptDownloadConstants.DOWNLOAD_TYPE_TSV,
                        data.rptName
                      )
                    "
                    >{{ data.rptName }}</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
  <LoadingOverlayComponent v-if="isLoading" :lines="loadLines" />
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  onMounted,
  ref,
  watch,
  onBeforeUnmount,
} from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import BreadcrumbsComponent from "../layout/BreadcrumbsComponent.vue";
import {
  formatMessage,
  outputDebugLogs,
  isTokenAlive,
  scrollToTop,
  commonHandleAxiosError,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import { useProcessingStore } from "../../store/useProcessingStore";
import "vue-loading-overlay/dist/css/index.css";
import LoadingOverlayComponent from "../layout/LoadingOverlayComponent.vue";

interface InputData {
  dateKbn: string; // 日付区分（1:発行日 2:売上日）
  dateFrom: string; // 開始日
  dateTo: string; // 終了日
}
interface agData {
  selection: boolean; // 選択
  agCode: string; // AGコード
  agName: string; // AG名
}
interface OutputData {
  agCode: string; // AGコード
  agName: string; // AG名
  rptName: string; // 売上日報ファイル名
}
interface KeyValueItem {
  id: string; // ID
  value: string; // 値
}

class UriRptDownloadConstants {
  // ダウンロード形式
  static readonly DOWNLOAD_TYPE_TSV = "1"; // tsvファイル
  static readonly DOWNLOAD_TYPE_ZIP = "2"; // zipファイル
  static readonly DOWNLOAD_TYPE_TEMPLATE = "3"; // テンプレートファイル

  // 日付区分
  static readonly DATE_KBN_ISSUE = "1"; // 発行日
  static readonly DATE_KBN_SALES = "2"; // 売上日

  // キー
  static readonly KEY_CHECK_SETTINGS_DATE_RANGE_DAYS = "DateRangeDays"; // 日付範囲（日数）
  static readonly KEY_CHECK_SETTINGS_START_DATE_LOOKBACK_MONTHS =
    "StartDateLookbackMonths"; // 開始日過去遡り月数
  static readonly KEY_DISPLAY_TEXT_PAST_TARGET_SPAN = "PastTargetSpan"; // 過去対象期間文言
  static readonly KEY_DISPLAY_TEXT_TEMPLATE_FILE = "TemplateFile"; // テンプレートファイルに関する文言
}

export default defineComponent({
  name: "UriRptDownloadComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BreadcrumbsComponent,
    BackToTop,
    LoadingOverlayComponent,
  },
  setup() {
    const router = useRouter();
    const { getCategoryIdByName } = useUserParmitionStore();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const { logoutUser } = useUserStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const daihyoCode = ref(""); // 代表コード
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const pseudoDaihyoCode = ref(""); // 疑似ログイン代表コード
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const serchDaihyoCode = ref(""); // 検索用代表コード
    const categoryId = ref(""); // カテゴリID
    const agList = ref<agData[]>([]); // AGデータリスト
    const displayMessages = ref<KeyValueItem[]>([]); // 画面メッセージリスト
    const checkSettings = ref<KeyValueItem[]>([]); // チェック設定リスト
    const webDateStr = ref(""); // WEB日付
    // 検索条件の入力データ
    const inputData = ref<InputData>({
      dateKbn: "",
      dateFrom: "",
      dateTo: "",
    });
    // 検索結果のデータリスト
    const outputDataList = ref<OutputData[]>([]);
    const outputSeq = ref(""); // 出力シーケンス
    const zipFileName = ref(""); // ZIPファイル名
    const isLoading = ref(false); // ブロッキングオーバーレイの表示フラグ
    const loadLines = ref<string[]>([]); // ブロッキングオーバーレイのメッセージ

    // IDから値を取得するユーティリティ関数
    const getValueById = (list: KeyValueItem[], id: string): string => {
      const item = list.find((x) => x.id === id);
      return item ? item.value : "";
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, false);
    };

    /**
     * 初期処理
     */
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          daihyoCode.value = parsedUserInfo.daihyoCode;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          pseudoDaihyoCode.value = parsedUserInfo.pseudoDaihyoCode;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
            serchDaihyoCode.value = daihyoCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
            serchDaihyoCode.value = pseudoDaihyoCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        // カテゴリID取得
        categoryId.value = getCategoryIdByName(
          AppConstants.CATEGORY_NAME_URI_RPT
        ) as string;

        // 初期表示データ取得API
        const response = await apiAuthClient.post(
          "/api/UriRptDownload/getInitialData",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            daihyoCode: serchDaihyoCode.value,
            kanriAgCode: pseudoAgCode.value,
            kanriUserId: pseudoUserId.value,
          }
        );

        // レスポンスからデータを取得
        const data = response.data;
        agList.value = data.agList;
        displayMessages.value = data.displayMessages;
        checkSettings.value = data.checkSettings;
        webDateStr.value = data.webDate;

        // 初期化
        initializeItems();

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * クリアボタン押下
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        // メッセージクリア
        errorMessage.value = "";
        // 入力項目クリア
        initializeItems();
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * 検索ボタン押下
     */
    const onSerch = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        errorMessage.value = "";

        // 入力チェック
        if (!validateInput()) {
          return;
        }

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        showLoading([
          "検索中です...",
          "画面を触らないでください",
          "検索条件によって時間がかかることがあります",
        ]);

        // 検索結果クリア
        outputDataList.value = [];

        // 売上日報情報一覧取得API実行
        const response = await apiAuthClient.post(
          "/api/UriRptDownload/getRptList",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            daihyoCode: serchDaihyoCode.value,
            agList: agList.value
              .filter((item) => item.selection)
              .map((item) => ({
                agCode: item.agCode,
              })),
            dateKbn: inputData.value.dateKbn,
            dateFrom: inputData.value.dateFrom,
            dateTo: inputData.value.dateTo,
          }
        );

        const data = response.data;
        outputDataList.value = data.searchResultList;
        outputSeq.value = data.outputSeq;
        zipFileName.value = data.zipFileName;

        if (outputDataList.value.length === 0) {
          errorMessage.value = formatMessage(
            messages.ERR_0009,
            "該当するデータ"
          );
          // スクロールを一番上に戻す
          scrollToTop();
          return;
        }
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        processingStore.isProcessing = false;
        hideLoading();
      }
    };

    /**
     * ダウンロードボタン押下
     */
    const onDownload = async (
      downloadType: string,
      downloadFileName: string
    ) => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        errorMessage.value = "";

        // 入力チェック

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 売上日報ダウンロードAPI実行
        const response = await apiAuthClient.post(
          "/api/UriRptDownload/downloadRpt",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            daihyoCode: serchDaihyoCode.value,
            outputSeq: outputSeq.value,
            downloadType: downloadType,
            downloadFileName: downloadFileName,
          },
          {
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;

        // サーバ側から返されたファイル名を取得
        const disposition = response.headers["content-disposition"];
        let fileName = "download.csv";
        if (disposition && disposition.includes("filename*=UTF-8")) {
          const matches = /filename\*=UTF-8''(.+)/.exec(disposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }

        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);

        // エラーメッセージを表示
        errorMessage.value = formatMessage(
          messages.ERR_SYS003,
          "ファイルダウンロード"
        );

        // スクロールを一番上に戻す
        scrollToTop();
      } finally {
        processingStore.isProcessing = false;
      }
    };

    const initializeItems = () => {
      for (const ag of agList.value) {
        ag.selection = true; // 初期状態では全て選択された状態にする
      }
      inputData.value.dateKbn = "";
      inputData.value.dateFrom = "";
      inputData.value.dateTo = "";
      outputDataList.value = [];
    };

    /**
     * 入力チェック
     */
    const validateInput = (): boolean => {
      const messageList = ref<string[]>([]);

      // 必須チェック
      if (agList.value.filter((item) => item.selection).length === 0) {
        errorMessage.value = formatMessage(
          messages.ERR_0003,
          "エージェントコード"
        );
        return false;
      }
      if (inputData.value.dateKbn == "" || inputData.value.dateKbn == "0") {
        errorMessage.value = formatMessage(messages.ERR_0041, "発行日/売上日");
        return false;
      }
      if (inputData.value.dateFrom == "") {
        errorMessage.value = formatMessage(messages.ERR_0001, "開始日");
        return false;
      }
      if (inputData.value.dateTo == "") {
        errorMessage.value = formatMessage(messages.ERR_0001, "終了日");
        return false;
      }

      // 開始日が、WEB日付の過去遡り月数の範囲内かどうかをチェック
      if (isStartDateBeforeLookbackLimit()) {
        errorMessage.value = formatMessage(
          messages.ERR_0045,
          "開始日",
          getValueById(
            checkSettings.value,
            UriRptDownloadConstants.KEY_CHECK_SETTINGS_START_DATE_LOOKBACK_MONTHS
          )
        );
        return false;
      }

      if (inputData.value.dateFrom && inputData.value.dateTo) {
        // 両方の値が入力されている場合、大小チェックを行う
        if (
          new Date(inputData.value.dateFrom) <= new Date(inputData.value.dateTo)
        ) {
          // チェックOK
        } else {
          errorMessage.value = formatMessage(
            messages.ERR_0005,
            "開始日",
            "終了日"
          );
          return false;
        }

        // 日付範囲チェック
        if (
          !isDateRangeValid(inputData.value.dateFrom, inputData.value.dateTo)
        ) {
          errorMessage.value = formatMessage(
            messages.ERR_0046,
            "開始日",
            "終了日",
            getValueById(
              checkSettings.value,
              UriRptDownloadConstants.KEY_CHECK_SETTINGS_DATE_RANGE_DAYS
            )
          );
          return false;
        }
      }

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**
     * 日付文字列をDateオブジェクトに変換するユーティリティ関数
     */
    const parseDate = (dateStr: string): Date | null => {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) {
        return null;
      }
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    /**
     * 月数を加算するユーティリティ関数
     */
    const addMonths = (date: Date, months: number): Date => {
      const newDate = new Date(date);
      newDate.setMonth(newDate.getMonth() + months);
      return new Date(
        newDate.getFullYear(),
        newDate.getMonth(),
        newDate.getDate()
      );
    };

    /**
     * 2つの日付の差分を日数で取得するユーティリティ関数
     */
    const getDateDiffDays = (
      dateFrom: string,
      dateTo: string
    ): number | null => {
      const from = parseDate(dateFrom);
      const to = parseDate(dateTo);
      if (from && to) {
        return Math.floor(
          (to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24)
        );
      }
      return null;
    };

    /**
     * 開始日が、WEB日付の過去遡り月数の範囲内かどうかをチェックするユーティリティ関数
     */
    const isStartDateBeforeLookbackLimit = (): boolean => {
      const startDate = parseDate(inputData.value.dateFrom);
      const webDate = parseDate(webDateStr.value);
      if (!startDate || !webDate) {
        // 日付のパースに失敗した場合は、開始日のチェックを行わない
        return false;
      }

      // 数値に変換してチェック
      const lookbackMonths = Number(
        getValueById(
          checkSettings.value,
          UriRptDownloadConstants.KEY_CHECK_SETTINGS_START_DATE_LOOKBACK_MONTHS
        )
      );
      if (!Number.isFinite(lookbackMonths)) {
        // 設定値が不正な場合は、開始日のチェックを行わない
        return true;
      }

      // WEB日付から過去遡り月数を引いた日付を計算
      const lookbackLimitDate = addMonths(webDate, -lookbackMonths);

      // 開始日が過去遡り月数の範囲内かどうかをチェック
      return startDate < lookbackLimitDate;
    };

    /**
     * 日付範囲が有効かどうかをチェックするユーティリティ関数
     */
    const isDateRangeValid = (dateFrom: string, dateTo: string) => {
      const diffDays = getDateDiffDays(dateFrom, dateTo);

      if (diffDays === null) {
        return false;
      }

      const rangeDays = Number(
        getValueById(
          checkSettings.value,
          UriRptDownloadConstants.KEY_CHECK_SETTINGS_DATE_RANGE_DAYS
        )
      );
      if (!Number.isFinite(rangeDays)) {
        // 設定値が不正な場合は、日付範囲のチェックを行わない
        return true;
      }

      return diffDays + 1 <= rangeDays;
    };

    /**
     * ローディングオーバーレイの表示
     */
    const showLoading = (lines: string[]) => {
      loadLines.value = lines;
      isLoading.value = true;
    };

    /**
     * ローディングオーバーレイの非表示
     */
    const hideLoading = () => {
      isLoading.value = false;
      loadLines.value = [];
    };

    let prevOverflow = ""; // 元のオーバーフロースタイルを保存する変数
    /**
     * ローディングオーバーレイ表示中のスクロール制御
     */
    watch(isLoading, (v) => {
      if (v) {
        prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = prevOverflow;
      }
    });

    /**
     * コンポーネントがアンマウントされる際にオーバーフローをリセット
     * - ローディングオーバーレイが表示されたままコンポーネントが破棄された場合でも、
     * - スクロールができなくなるのを防止するための措置
     */
    onBeforeUnmount(() => {
      document.body.style.overflow = prevOverflow;
    });

    /**
     *  全てのエージェントが選択されているかどうかを判定する算出プロパティ
     */
    const isAllChecked = computed(() => {
      return agList.value.length > 0 && agList.value.every((x) => x.selection);
    });

    /**
     *  全てのエージェントの選択状態を切り替える
     */
    const toggleAllAgents = (event: Event) => {
      const checked = (event.target as HTMLInputElement).checked;
      agList.value.forEach((agent) => {
        agent.selection = checked;
      });
    };

    return {
      AppConstants,
      UriRptDownloadConstants,
      onClear,
      onSerch,
      onDownload,
      initializeItems,
      toggleAllAgents,
      scrollToTop,
      formatMessage,
      getValueById,
      isInitError,
      isDataFetched,
      isLoading,
      loadLines,
      isKaunetAdmin,
      errorMessage,
      inputData,
      categoryId,
      agList,
      isAllChecked,
      outputDataList,
      zipFileName,
      displayMessages,
      checkSettings,
    };
  },
});
</script>
